export const JP_GENERIC_CODE = 'JP_GENERIC';
export const JP_GENERIC_CODE_SS = 'JP_GENERIC_SS'; //JP_GENERIC for self service
export const JP_EXCEPTION = 'JP_EXCEPTION';
export const JP_LOGGEDOUT = 'JP_LOGGEDOUT';
export const JP_DOD_DISAGREE = 'JP_DOD_DISAGREE';
export const JP_CHANGENOTALLOWED = 'JP_CHANGENOTALLOWED';
export const JP1 = 'JP1'; // Unacceptable vehicle value/points/accept code
export const JP2 = 'JP2'; //Driver or policyholders under minimum age
export const JP3 = 'JP3'; // Unacceptable location
export const JP3_SS = 'JP3_SS'; // Unacceptable location (self-service)
export const JP4 = 'JP4';
export const JP38 = 'JP38'; // Pet commercial use
export const JP_DISAGREE_CONDITIONS = 'JP31'; //User does not agree to General conditions when purchasing a quote
export const JP_DISAGREE_CONDITIONS_SS = 'JP31_SS'; //JP31 for self service
export const JP_PAYMENT_MAX_ATTEMPTS_REACHED = 'JP_PAYMENT_MAX_ATTEMPTS_REACHED';
export const JP79 = 'JP79';
export const JP_UNACCEPTABLE_PET_AGE = 'JP24';
export const JP_UNACCEPTABLE_BUILDING_CONDITION = 'JP21';
export const JP87 = 'JP87';
export const JP_FTTP_VEHICLE_MKT_VAL_UNDER = 'JP_FTTP_VEHICLE_MKT_VAL_UNDER';
export const JP_FTTP_VEHICLE_MKT_VAL_EXCEEDED = 'JP_FTTP_VEHICLE_MKT_VAL_EXCEEDED';
export const JP_TECHNICAL_CODE = 'JP_TECHNICAL';
export const JP_DOG_INELIGIBLE_BREED = 'JP_DOG_INELIGIBLE_BREED';
export const JP_GEOLIMITS = 'JP_GEOLIMITS';
export const JP_GEOLIMITS_SS = 'JP_GEOLIMITS_SS';
export const UnacceptableLocations = [JP3, JP3_SS, JP_GEOLIMITS, JP_GEOLIMITS_SS];
export const JP_JWL_UNDER16 = 'JP_JWL_UNDER16';

// JOR/RSA specific jeopardy codes
export const JP_RSA_GENERIC = 'JP_RSA_GENERIC';
export const JP_RSA_INELIGIBLE_VEHICLE = 'JP_RSA_INELIGIBLE_VEHICLE'; // Ineligible vehicle for RSA (too long, too heavy, etc.)
export const JP_RSA_INELIGIBLE_UPGRADE = 'JP_RSA_INELIGIBLE_UPGRADE'; // Vehicle ineligible for a RSA upgrade (doesn't meet business criteria)
export const JP_JOR_TECH_ERROR = 'JP_JOR_TECH_ERROR';
export const JP_JOR_EMERG = 'JP_JOR_EMERG'; // Jeopardy users in JOR form when they are in critical situation
export const JP_JOR_CREATE_JOB_FAIL = 'JP_JOR_CREATE_JOB_FAIL'; // Jeopardy when the Create Roadside job fails
export const JP_RSA_EXISTING_COVER = 'JP_RSA_EXISTING_COVER'; // Jeopardy when the there is an existing Roadside Assistance
export const JP_RSA_IS_NOT_COVERED = 'JP_RSA_IS_NOT_COVERED'; // Jeopardy when isEligibility check returns isCovered as false
export const JP_RSA_FLEET = 'JP_RSA_FLEET'; // Jeopardy when RSA for log a job - fleet

export const JP_PAYMENT_ERROR = 'JP_PAYMENT_ERROR';

// IQMQ specific jeopardy codes
export const JP_RIDE_SHARE = 'JP_RIDE_SHARE';

// IQHQ specific jeopardy codes
export const JP_Ineligible_Mobile_Items = 'JP_Ineligible_Mobile_Items';
export const Warning_Mobile_Value = 'MBMV';
export const Warning_Mobile_Ineligible = 'MBPH';
export const Warning_Home_Items = 'JP33';
export const JP_COMBINED_DISCOUNT_HOME = 'JP_COMBINED_DISCOUNT_HOME';
export const JP_COMBINED_DISCOUNT_CONTENTS = 'JP_COMBINED_DISCOUNT_CONTENTS';
export const JP_POLICY_PAID_LATER = 'JP_POLICY_PAID_LATER';

//Make a payment Jeopardy codes
export const JP_SERVICE_ERROR = 'JP_SERVICE_ERROR';

export const SS_IQ_SHARED_CODES: Record<string, string> = {
  JP31: 'JP31_SS',
};
